import { useChannel, useConnectionStateListener } from 'ably/react';
import { debounce } from 'lodash';
import { useCallback, useMemo, useState } from 'react';
import { useSubscriberId } from './components/SubscriberIdProvider';
import { useUnmount } from './hooks';
import { serverEventEmitter } from './utils';

export const useAblyPushing = () => {
  const subscriberId = useSubscriberId();

  // This hook wires the subscriber's channel with server-push event to the serverEventEmitter
  useChannel(`user-${subscriberId}`, 'server-push', ({ data }) => {
    serverEventEmitter.emit(data);
  });

  const [isOnline, setIsOnline] = useState(false);

  const debouncedOffline = useMemo(() => debounce(() => setIsOnline(false), 10000), []);

  const onConnected = useCallback(() => {
    debouncedOffline.cancel();
    setIsOnline(true);
  }, [debouncedOffline]);

  const onDisconnected = useCallback(() => {
    debouncedOffline();
  }, [debouncedOffline]);

  useConnectionStateListener((stateChange) => {
    if (stateChange.current === 'connected') {
      onConnected();
    } else if (stateChange.current === 'disconnected') {
      onDisconnected();
    }
  });

  useUnmount(() => {
    debouncedOffline.cancel();
  });

  return isOnline;
};
